module.exports = __webpack_public_path__ + "static/media/my_items.51ada05e.svg";